import React, { memo, PropsWithChildren } from "react";

export const CenteredSpan = memo(({ children }: PropsWithChildren) => {
  return <span style={{ verticalAlign: "-32%" }}>{children}</span>;
});
